<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="secondary-content">
      <div class="reprint-box" style="height: 42.03%">
        <div class="rbox2" style="width: 49.75%;position: relative" v-loading="loading1" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">报警趋势</h3>
          <div id="alarm21" style="width: 100%; height: 100%"></div>
        </div>
        <div class="rbox1" style="width: 49.75%;position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">报警位号</h3>
          <div id="alarm22" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="reprint-box" style="height: 56.83%">
        <div class="rbox1" style="border: none;justify-content: space-between;">
          <div style="position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">报警状态</h3>
            <div id="alarm23" style="width: 100%; height: 100%"></div>
          </div>
          <div style="position: relative" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">报警等级</h3>
            <div id="alarm24" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div class="rbox2" style="position: relative" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">报警详情</h3>
          <div id="alarm25" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="alarmdata1"
              height="100%"
              size="mini"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#31A487','font-size':'14px','border-bottom': '1px solid #31A487'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #fff; font-size: 10px">
              <el-table-column
                prop="alarmTime"
                label="报警时间">
              </el-table-column>
              <el-table-column
                prop="nameStr"
                label="位号名">
              </el-table-column>
              <el-table-column
                prop="levelNum"
                label="报警等级">
              </el-table-column>
              <el-table-column
                prop="typeName"
                label="报警类型">
              </el-table-column>
              <el-table-column
                prop="actTime"
                label="确认时间">
              </el-table-column>
              <el-table-column
                prop="delTime"
                label="消除时间">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/production-alarm-header";
import {getTime} from "../../bll/utils";

export default {
  name: 'ProductionAlarmAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  data () {
    return {
      loading1:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
      alarmdata1:[]
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/alarm/trend';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let series=[{
            name: datall.dataY.nameStr,
            type: 'line',
            smooth: true,
            areaStyle: {},
            color: '#FFF153',
            showSymbol: false,
            data:datall.dataY.num
          }]
          $this.Loadtrendline(series,datall.dataX,'alarm21')
          $this.loading1=false
        }
      })
      const url2 = '/api-portal/alarm/tagNumber';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let datall=datas.data
          datall.dataY.num=datall.dataY.num.map(val=>{
            return (val/1000000000000).toFixed(2)
          })
          console.log(datall)
          $this.alarmbarchart(datall)
          this.loading2=false
        }
      })
      const url3 = '/api-portal/alarm/state';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let arr=datas.data.map(val => {
            return {name:val.nameStr,value:(val.num/10000000000000000000).toFixed(1)}
          })
          $this.drawpiechart('alarm23',arr,'个数','千京','60%')
          this.loading3=false
        }
      })
      const url4 = '/api-portal/alarm/level';
      $this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let arr=datas.data.map(val => {
            return {name:val.nameStr,value:val.num}
          })
          $this.drawpiechart('alarm24',arr,'次','',['40%', '70%'])
          this.loading4=false
        }
      })
      const url5 = '/api-portal/alarm/detail';
      $this.$api.post(url5, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata1=datas.data
          this.loading=false
        }
      })
    },
    alarmbarchart (datas) {
      const myEchartst = this.$echarts.init(document.getElementById('alarm22'))
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} 亿`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: datas.dataX
        },
        yAxis: {
          type: 'value',
          splitLine: {show:false},
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return params+'万亿'
            }
          }
        },
        series: [
          {
            name: datas.dataY.nameStr,
            type: 'bar',
            barMaxWidth:40,
            color:'#31A487',
            data: datas.dataY.num
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
    Loadtrendline(datall,t,obj){
      const myEchartst = this.$echarts.init(document.getElementById(obj))
      var st = t[0]
      var ed = t[39]
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              let vals=item.data>100?(item.data/100000000).toFixed(2):item.data
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${vals} ${item.data>100?'亿':''}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '19%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB',
            // formatter: function (params) {
            //   return parseTime(params,'{y}-{m}-{d}')
            // }
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data:t
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show:false,
          },
          max:function (value) {
            return parseInt((value.max+9)/10)*10
          },
          min:function (value) {
            return parseInt((value.min-2)/10)*10
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#555656'
            }
          },
          axisLabel: {
            color: '#B6B6BB',
            formatter: function (params) {
              return parseInt(params/100000000)+'亿'
            }
          }
        },
        dataZoom: [
          {
            type: 'slider',
            borderColor:'#000',
            backgroundColor: 'rgba(47,69,84,0.8)',
            startValue: st,
            endValue: ed
          }
        ],
        series: datall
      }
      myEchartst.setOption(option)
      this.loading2=false
    },
    drawpiechart (id,data,name,nuit,rad) {
      const myEchartst = this.$echarts.init(document.getElementById(id))
      let option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.marker}${params.name}<br>${params.seriesName}：${params.value} ${nuit} （${params.percent}%）`
          }
        },
        color:['#2E88FF','#FE8433','#1FD3CD','#6D6DF2','#4CA2DC','#FFB70A','#DB7295','#89A7FA','#34ADA9','#EE6666','#7178BC','#CFA67C','#73C0DE','#5470C6'],
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'right',
          top: 'center',
          icon:'path://M85.333333 85.333333m53.333334 0l746.666666 0q53.333333 0 53.333334 53.333334l0 746.666666q0 53.333333-53.333334 53.333334l-746.666666 0q-53.333333 0-53.333334-53.333334l0-746.666666q0-53.333333 53.333334-53.333334Z',
          textStyle:{
            color:'#BDBDC1'
          }
        },
        series: [
          {
            name: name,
            type: 'pie',
            radius: rad,
            data: data,
            label: {
              show: true,
              formatter:`{b} \n{d}%`,
              textStyle:{
                color:'#F4F7FF'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 132px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-direction:column;
  color: #fff;
}

.reprint-box{
  box-sizing: border-box;
  height: 49.43%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reprint-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.rbox1{
  width: 33.5%;
  flex-direction:column;
}
.rbox1>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 48.8%;
  width: 100%;
}
.rbox2{
  width: 66%;
}
.el-table, .el-table__expanded-cell{
  background: none;
}

.nonebak:before{
  background: none;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/production-alarm-analysis2.vue